import { Modal, Stack } from '@mantine/core';

import CreateProjectForm from '@projects/components/CreateProjectForm/CreateProjectForm';
import useCreateProjectModal from './useCreateProjectModal';

import './CreateProjectModal.scss';

export type CreateProjectModalProps = {
	onClose: ( createdProjectID?: number ) => void,
	onProjectCreationSuccess?: ( projectID: number ) => void,
	onProjectCreationFailed?: () => void,
	initialWorkspaceID?: number
};

const CreateProjectModal = ( {
	onClose,
	onProjectCreationSuccess,
	onProjectCreationFailed,
	initialWorkspaceID
}: CreateProjectModalProps ) => {
	const {
		opened,
		isCreatingProject,
		onFormSubmitted
	} = useCreateProjectModal( {
		onProjectCreationFailed,
		onProjectCreationSuccess
	} );

	return (
		<Modal
			opened={opened}
			onClose={() => onClose()}
			size={540}
			title="Create New Project"
			closeButtonProps={{ size: 24 }}
			className="CreateProjectModal"
			centered
		>
			<Stack>
				<CreateProjectForm
					onSubmit={onFormSubmitted}
					isCreatingProject={isCreatingProject}
					initialWorkspaceID={initialWorkspaceID}
					onCancelClick={onClose}
				/>
			</Stack>
		</Modal>
	);
};

export default CreateProjectModal;
